
import React from 'react';

interface StatsBarProps {
  total: number;
  away: number;
  probation45: number;
  probation90: number;
  hiring: number;
  absencesMonth: number;
  /** Controles de rolagem horizontal do quadro (barra inferior) */
  boardCanScrollLeft?: boolean;
  boardCanScrollRight?: boolean;
  onBoardScrollLeft?: () => void;
  onBoardScrollRight?: () => void;
}

export const StatsBar: React.FC<StatsBarProps> = ({
  total,
  away,
  probation45,
  probation90,
  hiring,
  absencesMonth,
  boardCanScrollLeft = false,
  boardCanScrollRight = false,
  onBoardScrollLeft,
  onBoardScrollRight,
}) => {
  const showBoardScroll = typeof onBoardScrollLeft === 'function' && typeof onBoardScrollRight === 'function';

  return (
    <div className="fixed bottom-1 left-1/2 z-30 flex max-w-[min(100vw-0.75rem,64rem)] -translate-x-1/2 flex-nowrap items-center gap-2 px-1">
      {showBoardScroll && (
        <button
          type="button"
          aria-label="Rolar quadro para a esquerda"
          disabled={!boardCanScrollLeft}
          onClick={onBoardScrollLeft}
          className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-white/15 bg-slate-900/35 text-white shadow-[0_8px_32px_rgba(0,0,0,0.2)] backdrop-blur-md transition enabled:hover:bg-slate-900/50 enabled:focus:outline-none enabled:focus-visible:ring-2 enabled:focus-visible:ring-white/40 disabled:cursor-not-allowed disabled:opacity-35"
        >
          <span className="material-symbols-outlined !text-[22px]">chevron_left</span>
        </button>
      )}

      <div className="scrollbar-hide flex min-w-0 flex-1 items-center gap-2 overflow-x-auto rounded-full border border-white/10 bg-primary-accent px-3 py-1.5 text-xs shadow-[0_8px_32px_rgba(0,0,0,0.2)] backdrop-blur-md transition-transform hover:-translate-y-1 sm:gap-3 sm:px-4">
        {/* Total */}
        <div className="flex shrink-0 items-center gap-1.5 border-r border-white/10 pr-3">
          <span className="material-symbols-outlined text-secondary-accent !text-[16px]">group</span>
          <div className="flex flex-col leading-none">
            <p className="text-[8px] font-medium uppercase tracking-wider text-white/60">Total</p>
            <p className="text-sm font-bold text-white">{total}</p>
          </div>
        </div>

        {/* Afastados */}
        <div className="flex shrink-0 items-center gap-1.5 border-r border-white/10 pr-3">
          <span className="material-symbols-outlined text-red-400 !text-[16px]">medical_services</span>
          <div className="flex flex-col leading-none">
            <p className="text-[8px] font-medium uppercase tracking-wider text-white/60">Afastados</p>
            <p className="text-sm font-bold text-white">{away}</p>
          </div>
        </div>

        {/* Faltas Mês */}
        <div className="flex shrink-0 items-center gap-1.5 border-r border-white/10 pr-3">
          <span className="material-symbols-outlined text-pink-400 !text-[16px]">event_busy</span>
          <div className="flex flex-col leading-none">
            <p className="text-[8px] font-medium uppercase tracking-wider text-white/60">Faltas Mês</p>
            <p className="text-sm font-bold text-white">{absencesMonth}</p>
          </div>
        </div>

        {/* 45 Dias */}
        <div className="flex shrink-0 items-center gap-1.5 border-r border-white/10 pr-3">
          <span className="material-symbols-outlined text-orange-400 !text-[16px]">hourglass_top</span>
          <div className="flex flex-col leading-none">
            <p className="text-[8px] font-medium uppercase tracking-wider text-white/60">45 Dias</p>
            <p className="text-sm font-bold text-white">{probation45}</p>
          </div>
        </div>

        {/* 90 Dias */}
        <div className="flex shrink-0 items-center gap-1.5 border-r border-white/10 pr-3">
          <span className="material-symbols-outlined text-status-blue !text-[16px]">hourglass_bottom</span>
          <div className="flex flex-col leading-none">
            <p className="text-[8px] font-medium uppercase tracking-wider text-white/60">90 Dias</p>
            <p className="text-sm font-bold text-white">{probation90}</p>
          </div>
        </div>

        {/* Contratar */}
        <div className="flex shrink-0 items-center gap-1.5">
          <span className="material-symbols-outlined text-green-400 !text-[16px]">person_add</span>
          <div className="flex flex-col leading-none">
            <p className="text-[8px] font-medium uppercase tracking-wider text-white/60">Contratar</p>
            <p className="text-sm font-bold text-white">{hiring}</p>
          </div>
        </div>
      </div>

      {showBoardScroll && (
        <button
          type="button"
          aria-label="Rolar quadro para a direita"
          disabled={!boardCanScrollRight}
          onClick={onBoardScrollRight}
          className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-white/15 bg-slate-900/35 text-white shadow-[0_8px_32px_rgba(0,0,0,0.2)] backdrop-blur-md transition enabled:hover:bg-slate-900/50 enabled:focus:outline-none enabled:focus-visible:ring-2 enabled:focus-visible:ring-white/40 disabled:cursor-not-allowed disabled:opacity-35"
        >
          <span className="material-symbols-outlined !text-[22px]">chevron_right</span>
        </button>
      )}
    </div>
  );
};
